import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const createProfileSlice = (set) => ({
  Serie: [],
  setSerie: (newSerie) => set({ Serie: newSerie }),
  SerieVal: '',
  setSerieVal: (newSerieVal) => set({ SerieVal: newSerieVal }),
  ProfilesFetched: false,
  setProfilesFetched: (newProfilesFetched) => set({ ProfilesFetched: newProfilesFetched }),
  Profiles: [],
  setProfiles: (newProfiles) => set({ Profiles: newProfiles }),
  ProfileDesc: '',
  setProfileDesc: (newProfileDesc) => set({ ProfileDesc: newProfileDesc }),
  SelectedProfile: {},
  setSelectedProfile: (newSelectedProfile) => set({ SelectedProfile: newSelectedProfile }),
  SelectedProfileFetched: false,
  setSelectedProfileFetched: (newSelectedProfileFetched) =>
    set({ SelectedProfileFetched: newSelectedProfileFetched }),
  DummyData: [],
  setDummyData: (newDummyData) =>
    set((state) => ({ DummyData: state.DummyData.concat([newDummyData]) })),
  Gewicht: 0,
  calcGewicht: (länge) =>
    set((state) => ({
      Gewicht: (länge * parseFloat(state.SelectedProfile?.Lineargewicht) * 0.000001).toFixed(2),
    })),
});

const createInputSlice = (set) => ({
  Länge: 0,
  setLänge: (newLänge) =>
    set((state) => {
      state.calcGewicht(newLänge);
      return { Länge: newLänge };
    }),
  Punktlast: 0,
  setPunktlast: (newPunktlast) => set({ Punktlast: newPunktlast }),
  Streckenlast: 0,
  setStreckenlast: (newStreckenlast) => set({ Streckenlast: newStreckenlast }),
  b: 0,
  setb: (newb) => set({ b: newb }),
  Mt: 0,
  setMt: (newMt) => set({ Mt: newMt }),
  GewDurchbiegung: '',
  setGewDurchbiegung: (newGewDurchbiegung) => set({ GewDurchbiegung: newGewDurchbiegung }),
  ErsterPunktLast: 0,
  setErsterPunktLast: (newErsterPunktLast) => set({ ErsterPunktLast: newErsterPunktLast }),
  ErsterPunktDistanz: 0,
  setErsterPunktDistanz: (newErsterPunktDistanz) =>
    set({ ErsterPunktDistanz: newErsterPunktDistanz }),
  ZweiterPunktLast: 0,
  setZweiterPunktLast: (newZweiterPunktLast) => set({ ZweiterPunktLast: newZweiterPunktLast }),
  ZweiterPunktDistanz: 0,
  setZweiterPunktDistanz: (newZweiterPunktDistanz) =>
    set({ ZweiterPunktDistanz: newZweiterPunktDistanz }),
  DritterPunktLast: 0,
  setDritterPunktLast: (newDritterPunktLast) => set({ DritterPunktLast: newDritterPunktLast }),
  DritterPunktDistanz: 0,
  setDritterPunktDistanz: (newDritterPunktDistanz) =>
    set({ DritterPunktDistanz: newDritterPunktDistanz }),
  Radio: 'Einseitig',
  setRadio: (newRadio) => set({ Radio: newRadio }),
  Slider: 0,
  setSlider: (newSlider) => set({ Slider: newSlider }),
});

const createHelperSlice = (set) => ({
  Sprache: 'de',
  setSprache: (newSprache) => set({ Sprache: newSprache }),
  loadExportedState: (newState) => {
    set(newState);
  },
});

export const useFlexionStore = create(
  devtools(
    (...a) => ({
      ...createInputSlice(...a),
      ...createProfileSlice(...a),
      ...createHelperSlice(...a),
    }),
    { enabled: true }
  )
);
